import { z } from "zod";
import {
  CAMPAIGN_PERSONAS,
  CAMPAIGN_STATUSES,
  CONSENT_TIERS,
} from "../constants/index";
import { nonEmpty, uuid } from "./_primitives";

export const createCampaignSchema = z.object({
  name: nonEmpty,
  publicName: z.string().trim().optional(),
  industry: z.string().trim().optional(),
  ownerUserId: uuid,
  website: z.string().url().optional().or(z.literal("")),
  notes: z.string().optional(),
  consentTier: z.enum(CONSENT_TIERS).default("anonymized_only"),
  status: z.enum(CAMPAIGN_STATUSES).default("active"),
  // Audit V1: persona drives suggested playlist + welcome message when
  // composing a new issuance from this campaign.
  persona: z.enum(CAMPAIGN_PERSONAS).optional(),
  defaultPlaylistId: uuid.nullable().optional(),
  defaultWelcomeMessage: z.string().max(2000).nullable().optional(),
});

export const updateCampaignSchema = createCampaignSchema.partial();

export type CreateCampaignInput = z.infer<typeof createCampaignSchema>;
export type UpdateCampaignInput = z.infer<typeof updateCampaignSchema>;
